export const MUTATION_KEYS = {
    sendMegaGift: 'send_mega_gift'
}
